import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../../framework/entity/report/report-page/abstract-report-page";
import {EmployeePerformanceReportModel} from "./employee-performance-report.model";

@Component({
    selector: "wbo-employee-performance-report-page",
    templateUrl: "./employee-performance-report-page.component.html",
    providers: [provideReportModel(EmployeePerformanceReportModel)]
})
export class EmployeePerformanceReportPageComponent extends AbstractReportPage {

    constructor(public model: EmployeePerformanceReportModel) {
        super();
    }
}
